<template>
  <div class="fitness">
    <!-- Hero Section -->
    <section class="hero-section py-5">
      <div class="container">
        <div class="text-center mb-5">
          <h1 class="display-4 fw-bold text-primary">Your Wellness Journey</h1>
          <p class="lead text-muted">Track your fitness, nutrition, and wellness goals all in one beautiful space</p>
        </div>

        <!-- Navigation Tabs -->
        <FitnessNavigation
          :active-tab="activeTab"
          @tab-change="activeTab = $event"
        />
      </div>
    </section>

    <!-- Main Content -->
    <section class="py-4">
      <div class="container">
        <!-- Overview Tab -->
        <div v-if="activeTab === 'overview'">
          <FitnessOverview
            :workouts-this-week="workoutsThisWeek"
            :total-minutes="totalMinutes"
            :calories-burned="caloriesBurned"
            :avg-heart-rate="avgHeartRate"
            :steps-today="stepsToday"
            :water-glasses="waterGlasses"
            :exercise-minutes="exerciseMinutes"
          />
        </div>

        <!-- Exercise Tab -->
        <div v-if="activeTab === 'exercise'">
          <ExerciseTracker />
        </div>

        <!-- Nutrition Tab -->
        <div v-if="activeTab === 'nutrition'">
          <NutritionTracker />
        </div>

        <!-- Challenges Tab -->
        <div v-if="activeTab === 'challenges'">
          <ChallengesSection />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FitnessNavigation from './component/fitness/FitnessNavigation.vue'
import FitnessOverview from './component/fitness/FitnessOverview.vue'
import ExerciseTracker from './component/fitness/ExerciseTracker.vue'
import NutritionTracker from './component/fitness/NutritionTracker.vue'
import ChallengesSection from './component/fitness/ChallengesSection.vue'

export default {
  name: 'Fitness',
  components: {
    FitnessNavigation,
    FitnessOverview,
    ExerciseTracker,
    NutritionTracker,
    ChallengesSection
  },
  data() {
    return {
      activeTab: 'overview',
      // Overview data
      workoutsThisWeek: 3,
      totalMinutes: 125,
      caloriesBurned: 450,
      avgHeartRate: 142,
      stepsToday: 7543,
      waterGlasses: 6,
      exerciseMinutes: 25
    }
  },
  created() {
    // Set the active tab based on query parameter
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    }
  },
  watch: {
    // Watch for route changes
    '$route'(to, from) {
      if (to.query.tab) {
        this.activeTab = to.query.tab
      }
    }
  }
}
</script>

<style scoped>
.hero-section {
  background: linear-gradient(135deg, #fef7f7 0%, #f3e5f5 100%);
  color: #333;
}

.hero-section .text-primary {
  color: var(--primary-color) !important;
}

.hero-section .text-muted {
  color: #6c757d !important;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 3rem 0 !important;
  }

  .display-4 {
    font-size: 2rem;
  }
}
</style>
